
  import type { PropType } from 'vue';
  import { defineComponent } from 'vue';

  import SwitchTab from '@/common/components/redesigned/Tabs/SwitchTab.vue';

  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import type { TPresentationOption } from '../types/presentation';
  import PresentationMultiPageForm from './PresentationMultiPageForm.vue';
  import PresentationOnePageForm from './PresentationOnePageForm.vue';

  export default defineComponent({
    name: 'PresentationDownloadModal',
    components: {
      ModalComponent,
      SwitchTab,
      PresentationMultiPageForm,
      PresentationOnePageForm,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      countries: {
        type: Array as PropType<TPresentationOption[]>,
        default: () => [],
      },
      defaultCountryId: {
        type: [Number, String] as PropType<Nullable<number | string>>,
        default: null,
      },
    },
    emits: ['update:modelValue'],
    data(): { formKey: number; isLoading: boolean } {
      return {
        formKey: 0,
        isLoading: false,
      };
    },
    computed: {
      isOpen: {
        get(): boolean {
          return this.modelValue;
        },
        set(value: boolean) {
          this.$emit('update:modelValue', value);
        },
      },
    },
    watch: {
      modelValue(value: boolean) {
        if (value) {
          this.formKey += 1;
          this.isLoading = false;
        }
      },
    },
    methods: {
      onFormLoading(value: boolean) {
        this.isLoading = value;
      },
    },
  });
